import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import "../styles/taskCompletionConfirmModal.style.css";

export const TaskCompletionConfirmModal = ({
  title = "",
  description = "",
  onConfirm,
  isOpen = false,
  onCancel,
  centered = true,
  buttonText = "Proceed",
  image = null,
  width = 396,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onCancel}
      centered={centered}
      style={{ width }}
    >
      <ModalBody>
        <div className="confirm-modal-inner-content">
          {image && <img src={image} />}
          {title && <h4 className="title-md">{title}</h4>}
          {description && <p className="desc">{description}</p>}
          <div className="btn-groups">
            <Button
              onClick={onConfirm}
              color="primary"
              className="modal-btn blue-btn"
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
